import { IconName } from "react-frontier";

export type SidebarUrl = (url: string, params: any)=>string;

export interface SidebarItem{
	text?: string,
	icon?: IconName,
	path?: string | SidebarUrl,
	active_paths?: (string | SidebarUrl)[],
	login?: boolean,
	admin?: boolean,
	element?: (url: string, params: any)=>JSX.Element,
	key?: string,
	type?: 'item' | 'divider' | 'label' | 'element'
}

export interface UserBusiness{
	business_id: number,
	user_id: number,
	business_name: string,
	active: boolean,
	postings: number,
	date_created: number,
}

export interface Posting{
	posting_id: number,
	posting_name?: string,
	published?: number,
	date_created?: number,
	date_start?: number,
	date_end?: number,
	image?: string,
	approved?: number,
	business_name?: string,
	city?: string,
	state?: string,
	pay_rate: number,
	rate_type: number,
}

export interface ListPosting{
	posting_id: number,
	posting_name: string,
	business_name: string,
	date_start: number,
	date_end: number,
	location_name: string,
	min_pay_rate: number,
	max_pay_rate: number,
	city: string,
	state: string,
	distance?: number,
}

export interface BusinessUser{
	business_id: number,
	user_id: number,
	first_name: string,
	last_name: string,
	admin: boolean,
	image: string,
	email: string,
	user_adder: number,
	adder_first_name: string,
	adder_last_name: string,
	date_added: number,
}

export interface UserBusinessAccess{
	business_id: number,
	admin: boolean,
	access: number[]
}

export interface UserPostingAccess{
	posting_id: number,
	admin: boolean,
	access: number[]
}

export interface PostingForm{
	business_id: number,
	posting_name: string,
	rate_type: number,
	pay_rate: number,
	date_start: number,
	date_end: number,
	name?: string,
	phone?: string,
	street: string,
	exterior_number: string,
	interior_number?: string,
	neighborhood: string,
	city: string,
	state: string,
	zipcode: string,
	comments?: string
}

export interface BusinessPosting{
	posting_id: number,
	business_id: number,
	posting_name: string,
	date_start: number,
	date_end: number,
	location_id: number,
	approved: number,
	published: boolean,
	deleted: number,
	user_creator?: number,
	user_approved?: number,
	user_deleter?: number,
	date_created?: number,
	date_approved?: number,
	date_published?: number,
	date_deleted?: number,
	user_creator_name?: string,
	user_deleter_name?: string,
	location: Location,
	job_count?: number,
	description?: string
}

export interface PostingJob{
	job_id: number,
	posting_id: number,
	job_name: string,
	description: string,
	rate_type: number,
	pay_rate: number,
	job_count: number,
	published: boolean,
	deleted: boolean,
	user_creator?: number,
	user_deleted?: number,
	date_created: number,
	date_published?: number,
	date_deleted?: number,
	user_creator_name?: string,
	user_deleted_name?: string,
	job_users?: number,
	date_start: number,
	date_end: number
}

export interface JobUser{
	job_id: number,
	user_id: number,
	first_name: string,
	last_name: string,
	email: string,
	pay_rate: number,
	extra_amount: number,
	attendance_start: number,
	attendance_end: number,
	date_created: number,
	date_approved: number,
}

export interface PostingJobEdit extends PostingJob{
	users?: JobUser[],
	invites?: number,
}

export interface CreatePostingJob{
   job_name: string
	description: string
	rate_type: number
	pay_rate: number
	job_count: number
	date_start: number,
	date_end: number
}

export interface Location{
	location_id?: number,
	name?: string,
	phone?: string,
	street: string,
	exterior_number: string,
	interior_number?: string,
	neighborhood: string,
	city: string,
	state: string,
	zipcode: string,
	country?: string,
	lattitude?: number,
	longitude?: number,
	place_id?: string,
	comments?: string,
}

export enum RateType{
	'Otro' = 1,
	'Hora' = 2,
	'Día' = 3
}

export enum PostingStatus{
	MISSING_INFO = 1,
	PENDING_APPROVAL = 2,
	PUBLISHED = 80,
	NOT_PUBLISHED = 81,
	DELETED = 99,
}

export interface EditPostingInfo{
	posting_name?: string,
	date_start?: number,
	date_end?: number,
	description?: string
}

export interface EditPostingPayment{
	rate_type: number,
	pay_rate: number
}

export interface PostingWorker{
	posting_id: number,
	user_id: number,
	pay_rate?: number,
	extra_amount?: number,
	approved: number,
	rejected: number,
	reject_message?: string,
	user_approved?: number,
	user_rejected?: number,
	attendance_start?: number,
	attendance_end?: number,
	user_attendance_start?: number,
	user_attendance_end?: number,
	date_created: number,
	date_approved?: number,
	date_rejected?: number,
	image: string,
	worker_name: string,
	user_rejected_name: string,
	user_approved_name: string,
	job_name: string,
	job_id: number,
	first_name?: string,
	last_name?: string,
}

export interface PostingUser{
	user_id: number,
	first_name: string,
	last_name: string,
	image: string,
	email: string,
	phone: string,
	job_id: number,
	job_name: string,
	approved: boolean,
	rejected: boolean,
	date_created: number,
	date_rejected: number,
	date_approved: number,
	user_rejected_name?: string,
	worked: boolean,
	limit_available: boolean,
}

export interface Payout{
	payout_id: number;
	posting_id: number;
	paid: boolean;
	cancelled: boolean;
	user_creator: number;
	user_paid?: number;
	user_cancelled?: number;
	date_created?: number;
	date_paid?: number;
	date_cancelled?: number;
	total_paid: number;
	total_pending: number;
	posting_name?: string,
	employees: number,
	user_creator_name: string,
	business_name: string,
	business_id: number,
	user_payer_name?: string,
	users?: UserPayment[]
}

export interface UserPayment{
	payment_id: number
	user_id: number,
	amount: number,
	paid: boolean,
	cancelled: boolean,
	message: string,
	user_name: string,
	date_paid?: number,
	date_created: number,
	job_name: string,
	payer_name?: string,
}

export interface EditBusinessData{
	business_name: string,
	about?: string,
	website: string
}

export interface Business{
	business_id: number,
	business_name: string,
	email?: string,
	tax_info: number,
	user_creator: number,
	location_id?: number,
	date_created: number,
	user_creator_name?: string,
	tax_data: TaxInfo,
	location?: Location,
	about:string,
	website: string,
	active: boolean,
	deleted: boolean,
	payouts: Payout [],
	postings: Posting [],
}

export interface TaxInfo{
	tax_id: number,
	location_id: number,
	legal_name: string,
	rfc: string,
	email: string,
	regimen: string,
	use_cfdi: string,
	deleted: boolean,
	date_created: number,
	date_deleted?: number,
	location: Location
}

export interface PostingInfo{
	posting_id: number,
	business_id: number,
	posting_name: string,
	rate_type: number,
	pay_rate: number,
	date_start: number,
	date_end: number,
	location_id: number,
	date_published: number,
	business_name: string,
	about: string,
	website: string,
	date_created: number,
	location: Location,
	description: string,
	jobs: PostingJob []
}

export interface PublicPosting{
	posting_id: number,
	posting_name: string,
	business_id: number,
	business_name: string,
	description: string,
	location_id: number,
	date_start: number,
	date_end: number,
	location: Location,
	business_about: string,
	business_website: string,
	jobs: {
		job_id: number,
		job_name: string,
		date_published: number,
		date_start: number,
		date_end: number,
		pay_rate: number,
		rate_type: number,
		description: string,
		available: boolean,
	}[]
}

export interface JobWorker{
	posting_id: string
	pay_rate: number
	approved: boolean
	rejected: boolean
	posting_name?: string
	business_name?: string
	date_start: number
	date_end: number
	attendance_start: number
	attendance_end: number
	job_id: number
	job_name: string
	date_approved: number
}

export type SetLoading = (loading: boolean)=>void;

export interface GooglePlacesResult{
	address_components?: {
		long_name: string,
		short_name: string,
		types: string[]
	}[],
	adr_address?: string,
	geometry?: {
		location?: {
			lat: ()=>number,
			lng: ()=>number,
		},
	},
	icon?: string,
	icon_background_color?: string,
	icon_mask_base_uri?: string,
	name?: string,
	// photos?: {
	// 	height?: number,
	// 	width?: number,
	// 	html_attributions?: string[],
	// 	photo_reference?: string,
	// }[],
	place_id?: string,
	reference?: string,
	types?: string[],
	url?: string,
	utc_offset?: number,
	vicinity?: string,
}

export enum PayRateType{
	FIXED = 1,
	HOURLY = 10,
	DAILY = 20,	
}

export interface OnboardingUser{
	user_id: number,
	onboarded: boolean,
	first_name: string,
	last_name: string,
	email: string,
	phone: string,
	curp: string,
	rfc: string,
	images: {
		id: boolean,
		address: boolean,
	},
	accounts: {
		account_id: number,
		primary_account: boolean,
		name_account: string,
		rfc: string,
		curp: string,
		bank: string,
		clabe: string,
		card_number: string,
		postal_code: string,
	}[],
	address: Location
}

export interface OnboardingStageProps{
	user: OnboardingUser,
	setUser: (user: OnboardingUser)=>void,
	onFinish: ()=>void,
}

export enum DepositType{
	SPEI = 1,
	CARD = 2,
}

export interface BankAccount{
	account_id: number,
	name_account: string,
	primary_account: boolean,
	rfc?: string,
	curp?: string,
	bank?: string,
	bank_participant?: number,
	clabe: string,
	card_number: string,
	postal_code: string,
	email_account?: string,
	date_created?: number,
}

export enum BankAccountOwnerType{
	FISICA = 1,
	MORAL = 2,
}

export interface BankAccountForm{
	type: DepositType,
	primary_account: boolean,
	email?: string,
	account_owner: string
	clabe: string,
	card_number: string,
	bank_participant: number,
	rfc: string,
	postal_code: string,
	owner_type: BankAccountOwnerType,
}

export interface PaymentLog{
	payment_id: number,
	job_id: number,
	posting_id: number,
	posting_name: string,
	job_name: string,
	account_id: number,
	amount: number,
	message: string,
	paid: boolean,
	business_id: number,
	business_name: string,
	clabe: string,
	card_number: string,
	date_created: number,
	date_paid: number,
}

export interface MoneySummary{
	total_pending: number,
	total_held: number,
	total_available: number,
	total_paid: number,
	total: number,
}

export interface UserBankAccount{
	account_id: number,
	primary_account: boolean,
	name_account: string,
	rfc?: string,
	curp?: string,
	bank?: string,
	clabe: string,
	card_number: string,
	postal_code: string,
}

export interface UserInfoStats{
	user_id: number,
	image: string,
	fist_name: string,
	last_name: string,
	zipcode: number,
	city: string,
	state: string,
	postings: number,
	businesses: number
}

export interface User{
	user_id: number,
	first_name?: string,
	last_name?: string,
	email: string,
	phone: string,
	password: string,
	zipcode?: string,
	curp?: string,
	rfc?: string,
	user_secret?: number,
	address_location?: number,
	apple_auth?: string,
	google_auth?: string,
	onboarded: boolean,
	admin: boolean,
	banned: boolean,
	date_created?: number,
	date_ban?: number,
	image?: string,
	payments: PaymentLog[],
	summary: MoneySummary,
	location: Location
}

export enum PostingUserStatus{
	APPROVED = 1,
	REJECTED = 2,
	PENDING = 3
}